module.exports = __webpack_public_path__ + "static/img/bg-tr.37a9cfd1.png";